import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { Box, Grid, Paper, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import styles from "../../../styles.module.css";
import tempoLoadingService from "../../../services/tempoLoadingService";

  import cylinderMasterService from '../../../services/masters/cylinderMaster.Service';
import {
    AddButton,
    Breadcrumb,
    CustomePopover,
    DeleteDialog,
    ExcelDownload,
    SearchInput,
    StyledTableCell,
    StyledTableRow,
} from "../../reusableComponent/Reusables";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const List_New_Receipt = () => {
    const navigate = useNavigate(); // Initialize useNavigate
    const login_details = sessionStorage.getItem("loginUser");
    const userD = JSON.parse(login_details);
    const userInfo = userD.result.userInfo;

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState(null);
    const [sortBy, setSortBy] = useState(null);
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false); // Add snackbar state
    const totalCount = useSelector((state) => state.customer.total_count || 0);
    const defaultRowsPerPage = useSelector((state) => state.customer.rows_per_page || 15);

    const fields = ["dcs_no", "entry_date", "driver_name", "vehicle_no"];
    const labels = ["DC No", "DC Date", "Driver Name", "Vehicle No"];
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: defaultRowsPerPage,
    });

    const [successMessage, setSuccessMessage] = useState(null);
      const [cylinder, setCylinder] = useState([]);



    useEffect(() => {
  async function fetchData() {
    try {
      const [cylinderData] = await Promise.all([
        cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: '' }),
      ]);

      console.log('Fetched cylinderData:', cylinderData);

      if (!Array.isArray(cylinderData)) {
        throw new Error('cylinderData is not an array');
      }

      setCylinder(cylinderData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  fetchData();
}, []);


    useEffect(() => {
        setController((prev) => ({
            ...prev,
            rowsPerPage: defaultRowsPerPage,
            page: 0,
        }));
    }, [defaultRowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setController((prev) => ({
            ...prev,
            page: newPage,
        }));
    };

    const handleChangeRowsPerPage = (event) => {
        setController((prev) => ({
            ...prev,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0,
        }));
    };

    const fetchData = async () => {
        try {
            const params = {
                page: controller.page,
                size: controller.rowsPerPage,
                searchKey: searchKey,
            };
            const response = await tempoLoadingService.getTempoloadingList(params);
            setRows(response || []);
        } catch (error) {
            setSuccessMessage("Error fetching data");
            setOpenSnackbar(true);
            console.error("Fetch error:", error);
        }
    };

    const handleSearch = async (e) => {
        const searchValue = e.target.value;
        setSearchKey(searchValue);
        setController((prev) => ({ ...prev, page: 0 }));
        await fetchData();
    };

    useEffect(() => {
        fetchData();
    }, [controller, searchKey]);

    const deleteRecord = async (id) => {
        try {
            await tempoLoadingService.editDeleteTempoloading({
                tempo_loading_id: id,
                changedUpdatedValue: "delete",
            });
            setIsDelete(false);
            setDeleteInfo(null);
            setSuccessMessage("Record deleted successfully");
            setOpenSnackbar(true);
            await fetchData();
        } catch (error) {
            setSuccessMessage("Error deleting record");
            setOpenSnackbar(true);
            console.error("Delete error:", error);
        }
    };

    const handleDelete = (data) => {
        setIsDelete(true);
        setDeleteInfo(data);
    };

    const handleClose = () => {
        setIsDelete(false);
        setDeleteInfo(null);
    };

    const handleSort = (field) => {
        const newSortBy = sortBy === field ? null : field;
        setSortBy(newSortBy);

        if (newSortBy) {
            setRows((prevRows) =>
                [...prevRows].sort((a, b) => {
                    if (a[newSortBy] < b[newSortBy]) return -1;
                    if (a[newSortBy] > b[newSortBy]) return 1;
                    return 0;
                })
            );
        } else {
            fetchData();
        }
    };


const handleInspect = async (row) => {
  try {
    console.log('Row data in handleInspect:', row);

    let mappedRow = {
      cylinder_no: row.dcs_no || '',
      tag_no: row.tag_no || '',
      cyl_id: row.cyl_id || '',
      valve_condition: 'Ok',
      fusible_plug: 'Ok',
      painting: 'Ok',
      cyl_cap_avl: 'Ok',
      eci_result: '',
      current_tare_wt: '',
      actual_tare_wt: '',
      actual_tare_wt_aft_sol: '',
      qty_solvent: '',
      acetone_drum_tag_no: '',
      from_plant: '',
      to_plant: '',
      shift_time: '08:00',
      shift: 'shift1',
      done_by: row.driver_name || '',
      owner: row.owner || 'N/A',
      cust_name: row.cust_name || '',
    };

    // If required values are missing, fetch from cylinder master
    // if (!row.cyl_id || !row.tag_no) {
    //   const response = await cylinderMasterService.getCylinderList({ searchKey: row.dcs_no });
    //   const cylinder = Array.isArray(response) ? response[0] : null;

    //   console.log('Fetched cylinderData:', cylinder);

    //   if (!cylinder) {
    //     throw new Error('Cylinder not found');
    //   }

    //   mappedRow = {
    //     ...mappedRow,
    //     cylinder_no: cylinder.tag_no || row.dcs_no || '',
    //     cyl_id: cylinder.cyl_id || '',
    //     tag_no: cylinder.cylinder_no || '',
    //     current_tare_wt: cylinder.tare_wt || '',
    //     owner: cylinder.owner || 'N/A',
    //     cust_name: cylinder.cust_name || '',
    //   };
    // }

    // Navigate to inspection page with prefilled data
    navigate('/storeEntries/add-eci', {
      state: {
        rowData: mappedRow,
        openDialog: true,
      },
    });
  } catch (error) {
    console.error('Error fetching cylinder data:', error);
    setSuccessMessage('Error fetching cylinder details');
    setOpenSnackbar(true);
  }
};


    const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
   const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


    return (
        <Box className={styles.cts_page} sx={{ padding: '0px !important', margin: '0px !important' }}>
            <Box className={styles.body}>
                <Breadcrumb routeSegments={[{ name: "New Receipt" }]} />

                <HeaderSection
                    title="New Receipt"
                    searchKey={searchKey}
                    handleSearch={handleSearch}
                    sortedRows={sortedRows}
                    fields={fields}
                    labels={labels}
                    filename="New Receipt"
                    paginationInfo={paginationInfo}
                    controller={controller}
                    handleChangePage={handleChangePage}
                />

                <Paper sx={{ width: '100%' }}>
                    <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" sx={{ width: '20%' }} className={styles.table_head} onClick={() => handleSort("entry_no")}>
                                        Cylinder No
                                        <span className={styles.sort_icon}>{sortBy === "entry_no" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: '20%' }} className={styles.table_head} onClick={() => handleSort("entry_date")}>
                                        Tag No
                                        <span className={styles.sort_icon}>{sortBy === "entry_date" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: '20%' }} className={styles.table_head} onClick={() => handleSort("driver_name")}>
                                        Owner
                                        <span className={styles.sort_icon}>{sortBy === "driver_name" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="left" sx={{ width: '20%' }} className={styles.table_head} onClick={() => handleSort("driver_name")}>
                                        Status
                                        <span className={styles.sort_icon}>{sortBy === "driver_name" ? "▲" : "▼"}</span>
                                    </StyledTableCell>
                                    <StyledTableCell align="center" className={styles.table_head}>
                                        Action
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody sx={{ backgroundColor: '#fff' }}>
                                {Array.isArray(rows) && rows.length > 0 ? (
                                    sortedRows.map((row, index) => (
                                        <StyledTableRow key={row.tempo_loading_id || index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {row.dcs_no || 'N/A'}
                                            </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {row.tag_no || 'N/A'}
                                            </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {row.driver_name || 'N/A'}
                                            </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                {row.status || 'N/A'}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <button
                                                    onClick={() => handleInspect(row)}
                                                    style={{
                                                        padding: "4px 12px",
                                                        margin: "4px 12px",
                                                        backgroundColor: "#1976d2",
                                                        color: "white",
                                                        border: "none",
                                                        borderRadius: "4px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    Inspect
                                                </button>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))
                                ) : (
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={5} align="center">
                                            No data available
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>

                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.tempo_loading_id || null}
                    displayName={deleteInfo?.entry_no || deleteInfo?.tempo_loading_id || ""}
                />

                <ReusableSnackbar
                    open={openSnackbar}
                    onClose={() => setOpenSnackbar(false)}
                    message={successMessage}
                    autoHideDuration={3000}
                    vertical="top"
                    horizontal="right"
                />
            </Box>
        </Box>
    );
};

export default List_New_Receipt;